import React, { ReactElement, useEffect, useState } from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import 'dayjs';

import Header from './Header';
import Footer from './Footer';

import PrevIcon from 'img/arrow_prev.png';
import NextIcon from 'img/arrow_next.png';

import '../css/AdminManageUsers.css';
import dayjs from 'dayjs';
import { listNotices, removeNotice } from '../api';

const Columns = styled.div`
  display: grid;
  grid-template-columns: 140px 260px 80px 160px 140px;
  align-items: center;
`;

const ColumnTitle = styled.div`
  font-family: NotoSansKR;
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  text-align: left;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  box-shadow: inset 0 -1px 0 0 #ffffff;
`;

interface NoticeInfo {
  id: string;
  author: string;
  category: string;
  title: string;
  content: string;
  writtenAt: Date;
}

export default withRouter(function AdminManageNotices(props: RouteComponentProps): ReactElement {
  const { t } = useTranslation();

  const maxUserCount = 10;
  const maxPageCount = 9;

  const [page, setPage] = useState<number>(0);
  const [allNotices, setAllNotices] = useState<NoticeInfo[]>([]);
  const [notices, setNotices] = useState<NoticeInfo[]>([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    const session = localStorage.getItem('session');

    if (!session) {
      props.history.push('/signin');
      return;
    }

    (async () => {
      const result = await listNotices();
      if (result == null) {
        return;
      }
      console.log(result);
      setAllNotices(result);
      setNotices(result);
    })();
  }, []);

  useEffect(() => {
    setNotices(
      allNotices.filter(
        (info) => info.author.toLowerCase().includes(search.toLowerCase()) || info.title.toLowerCase().includes(search.toLowerCase()),
      ),
    );
  }, [search]);

  return (
    <div className="App">
      <ToastContainer />
      <Header />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '96px auto 180px' }}>
        <div className="admin-box">
          <div style={{ display: 'flex', height: '35px' }}>
            <div className="admin-box-title">고객센터 관리</div>
            <span style={{ margin: 'auto' }} />
            <input className="admin-box-search" placeholder="검색" type="text" value={search} onChange={(e) => setSearch(e.target.value)} />
            <div style={{ width: '10px' }} />
            <div style={{ width: '114px' }}>
              <button
                className="admin-box-b1"
                onClick={() => {
                  props.history.push('/write-notice');
                }}
              >
                새 공지 작성
              </button>
            </div>
          </div>
          <div style={{ height: '10px' }} />
          <div style={{ display: 'flex' }}>
            <button className="admin-box-tab" disabled={true}>
              공지사항
            </button>
            <div style={{ width: '20px' }} />
            <Link to="/manage-enquiries" className="admin-box-tab">
              1대1 문의하기
            </Link>
            <div style={{ width: '20px' }} />
            <Link to="/manage-faqs" className="admin-box-tab">
              자주하는 질문
            </Link>
            <div style={{ width: '20px' }} />
            <Link to="/manage-business-enquiries" className="admin-box-tab">
              비즈니스 1대1
            </Link>
          </div>
          <div style={{ height: '20px' }} />
          <Columns>
            <ColumnTitle>카테고리</ColumnTitle>
            <ColumnTitle>제목</ColumnTitle>
            <ColumnTitle>작성자</ColumnTitle>
            <ColumnTitle>날짜</ColumnTitle>
            <ColumnTitle>관리</ColumnTitle>
          </Columns>
          <div style={{ height: '10.5px' }} />
          <div style={{ height: '1px', border: 'solid 1px #ffffff' }} />
          {notices.slice(page * 10, Math.min((page + 1) * 10, notices.length)).map((info) => (
            <RowData
              info={info}
              onEdit={() => {
                props.history.push(`write-notice?id=${info.id}`);
              }}
              onRemove={() => {
                (async () => {
                  const result = await removeNotice(info.id);
                  if (result && result) window.location.reload();
                })();
              }}
            />
          ))}
          {notices.length > maxUserCount && (
            <>
              <div style={{ height: '10px' }} />
              <div style={{ display: 'flex', margin: '0 auto' }}>
                <button
                  className="admin-page"
                  onClick={() => {
                    setPage((val) => Math.max(0, val - 1));
                  }}
                >
                  <img src={PrevIcon} />
                </button>
                {Math.ceil(notices.length / maxUserCount) > maxPageCount ? (
                  <>
                    <button className="admin-page" onClick={() => setPage(0)} disabled={page == 0}>
                      1
                    </button>
                    {page > maxPageCount / 2 && <div className="admin-page">…</div>}
                    {Array.from({ length: maxPageCount - 2 }, (v, i) => {
                      const pageNum =
                        Math.min(
                          Math.max(Math.floor(maxPageCount / 2), page),
                          Math.ceil(notices.length / maxUserCount) - Math.ceil(maxPageCount / 2),
                        ) +
                        i -
                        Math.floor((maxPageCount - 2) / 2);
                      return (
                        <button className="admin-page" onClick={() => setPage(pageNum)} disabled={page == pageNum}>
                          {pageNum + 1}
                        </button>
                      );
                    })}
                    {page < Math.ceil(notices.length / maxUserCount) - Math.ceil(maxPageCount / 2) && <div className="admin-page">…</div>}
                    <button
                      className="admin-page"
                      onClick={() => setPage(Math.ceil(notices.length / maxUserCount) - 1)}
                      disabled={page == Math.ceil(notices.length / maxUserCount) - 1}
                    >
                      {Math.ceil(notices.length / maxUserCount)}
                    </button>
                  </>
                ) : (
                  <>
                    {Array.from({ length: Math.ceil(notices.length / maxUserCount) }, (v, i) => {
                      return (
                        <button className="admin-page" onClick={() => setPage(i)} disabled={page == i}>
                          {i + 1}
                        </button>
                      );
                    })}
                  </>
                )}

                <button
                  className="admin-page"
                  onClick={() => {
                    setPage((val) => Math.min(val + 1, Math.ceil(notices.length / maxUserCount) - 1));
                  }}
                >
                  <img src={NextIcon} />
                </button>
              </div>
            </>
          )}
          <div style={{ height: '20px' }} />
        </div>
      </div>
      <span style={{ margin: 'auto' }} />
      <Footer />
    </div>
  );
});

const RowData = (props: { info: NoticeInfo; onEdit: () => void; onRemove: () => void }) => {
  return (
    <Row>
      <Columns>
        <div className="admin-box-row-h2">{props.info.category}</div>
        <div className="admin-box-row-h2">{props.info.title}</div>
        <div className="admin-box-row-h2">{props.info.author}</div>
        <div className="admin-box-row-h6">{dayjs(props.info.writtenAt).format('YYYY.MM.DD')}</div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ width: '60px', height: '30px' }}>
            <button className="admin-box-row-b1" onClick={props.onEdit}>
              수정
            </button>
          </div>
          <div style={{ width: '60px', height: '30px' }}>
            <button className="admin-box-row-b2" onClick={props.onRemove}>
              삭제
            </button>
          </div>
        </div>
      </Columns>
    </Row>
  );
};
